class FileInfo extends Backbone.Model {}

FileInfo.FILEUPLOADSTATES = {
    QUEUED: "queued",
    INPROGRESS: "inprogress",
    ABORTED: "aborted",
    COMPLETE: "complete",
    ERROR: "error"
};

FileInfo.prototype.defaults = {
    filename: null,
    contentType: null,
    size: null
};

export default FileInfo;



// WEBPACK FOOTER //
// ./app/jsmodel/FileInfo.js